var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackOffice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4485_8897)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.86923 11.0303C7.54406 6.28743 8.88148 3.91602 10.9999 3.91602C13.1174 3.91602 14.4557 6.28743 17.1306 11.0303L17.4642 11.6215C19.6871 15.5632 20.7991 17.534 19.7944 18.975C18.7897 20.416 16.3037 20.416 11.3336 20.416H10.6662C5.69606 20.416 3.21006 20.416 2.20539 18.975C1.20073 17.534 2.31264 15.5632 4.53556 11.6215L4.86923 11.0303ZM10.9999 7.81185C11.1822 7.81185 11.3571 7.88428 11.486 8.01321C11.615 8.14214 11.6874 8.31701 11.6874 8.49935V13.0827C11.6874 13.265 11.615 13.4399 11.486 13.5688C11.3571 13.6977 11.1822 13.7702 10.9999 13.7702C10.8176 13.7702 10.6427 13.6977 10.5138 13.5688C10.3848 13.4399 10.3124 13.265 10.3124 13.0827V8.49935C10.3124 8.31701 10.3848 8.14214 10.5138 8.01321C10.6427 7.88428 10.8176 7.81185 10.9999 7.81185ZM10.9999 16.7493C11.243 16.7493 11.4762 16.6528 11.6481 16.4809C11.82 16.309 11.9166 16.0758 11.9166 15.8327C11.9166 15.5896 11.82 15.3564 11.6481 15.1845C11.4762 15.0126 11.243 14.916 10.9999 14.916C10.7568 14.916 10.5236 15.0126 10.3517 15.1845C10.1798 15.3564 10.0832 15.5896 10.0832 15.8327C10.0832 16.0758 10.1798 16.309 10.3517 16.4809C10.5236 16.6528 10.7568 16.7493 10.9999 16.7493Z",
    fill: "#251169"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4485_8897"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 23,
    fill: "white",
    transform: "translate(0 0.888672)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackOffice);
export default __webpack_public_path__ + "static/media/back_office.a3adeae0b306bf384936cd13405ca283.svg";
export { ForwardRef as ReactComponent };